module.exports = __webpack_public_path__ + "static/media/Elevation Ashutosh Ji.2b285be5.jpg";